import React from "react";
import { Box, Container } from "@mui/material";

const PageShell = ({
  children,
  maxWidth = "xl",
  className,
  sx,
  containerSx,
  ...props
}) => {
  return (
    <Box className={className} sx={{ py: 2, ...sx }} {...props}>
      <Container maxWidth={maxWidth} sx={containerSx}>
        {children}
      </Container>
    </Box>
  );
};

export default PageShell;
